import Head from 'next/head'
import { useTranslation } from 'react-i18next'

const Title: React.FC = ({ children }) => {
  const { t } = useTranslation()

  if (typeof children !== 'string') {
    throw new Error('<Title> must have a single child of type string')
  }

  return (
    <Head>
      <title>{t('site.pageTitle', { pageTitle: children })}</title>
    </Head>
  )
}

export default Title
